import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import BatchBadge from '../../../common/batch/BatchBadge'

const ActiveJobListRow = ({ item, selected, percentage, onSelect, batchBadge = null }) => {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onSelect()
    }
  }

  return (
    <Box
      role='button'
      tabIndex={0}
      aria-pressed={selected}
      aria-label={`${item.fabricationOrder.fabricationOrder}, ${item.jobReference.node?.name || ''}, ${typeof percentage === 'number' ? percentage : 0}%`}
      onClick={onSelect}
      onKeyDown={handleKeyDown}
      sx={{
        p: 1,
        borderRadius: 1,
        border: selected ? 2 : 1,
        borderColor: selected ? 'primary.main' : 'divider',
        bgcolor: selected ? 'background.paper' : 'action.default',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        transition: 'background-color 0.15s ease, border-color 0.15s ease',
        '&:hover': {
          borderColor: selected ? 'primary.main' : 'primary.light',
          bgcolor: selected ? 'action.selected' : 'action.hover'
        },
        '&:focus-visible': {
          outline: '2px solid',
          outlineColor: 'primary.main'
        }
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 0.5 }}>
        <BatchBadge badge={batchBadge} />
        <Typography variant='subtitle2' noWrap sx={{ fontWeight: 'bold', flexGrow: 1 }}>
          {item.fabricationOrder.fabricationOrder}
        </Typography>
        {/* S143: this is the JOB's own progress (a per-row quantity), never a batch-wide one --
            there is no aggregate across the rows anywhere in this list. */}
        {typeof percentage === 'number' && (
          <Typography variant='caption' color='success.main' sx={{ fontWeight: 'bold' }}>
            {percentage}%
          </Typography>
        )}
      </Box>
      {/* S143 (CA4.1): the part reference, so every job in the master-detail is distinguishable
          on its own -- not just by its fabrication order. */}
      <Typography variant='caption' color='text.secondary' noWrap>
        {item.fabricationOrder.partReference?.code || ''}
      </Typography>
      <Typography variant='caption' color='text.secondary' noWrap>
        {item.jobReference.node?.name || ''}
      </Typography>
      <Box sx={{ width: '100%', height: 4, borderRadius: 1, bgcolor: 'action.hover' }}>
        <Box sx={{ width: `${typeof percentage === 'number' ? percentage : 0}%`, height: '100%', borderRadius: 1, bgcolor: 'success.main', transition: 'width 0.2s ease' }} />
      </Box>
    </Box>
  )
}

ActiveJobListRow.propTypes = {
  batchBadge: PropTypes.shape({ color: PropTypes.string, label: PropTypes.string }),
  item: PropTypes.shape({
    fabricationOrder: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      fabricationOrder: PropTypes.string,
      partReference: PropTypes.shape({
        code: PropTypes.string
      })
    }).isRequired,
    jobReference: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      node: PropTypes.shape({
        name: PropTypes.string
      })
    }).isRequired
  }).isRequired,
  selected: PropTypes.bool.isRequired,
  percentage: PropTypes.number,
  onSelect: PropTypes.func.isRequired
}

export default React.memo(ActiveJobListRow)
